export enum OperatorFilterEnum {
  EQUALS = 'eq',
  NOT_EQUALS = 'neq',
  LT = 'lt',
  LTE = 'lte',
  GT = 'gt',
  GTE = 'gte',
  STARTSWITH = 'startswith',
  ENDSWITH = 'endswith',
  CONTAINS = 'contains',
  NOT_CONTAINS = 'doesnotcontain',
}
